import React from "react";
import CloseButton from "./CloseButton";
import Selectric from "./Selectric";
import DashboardCollapse from "./DashboardCollapse";

export default function PageSizeSelect(props) {

    const { viewLabel,
        closeViewLabel,
        pageSize,
        pageSizeOptions,
        activeDashboardCollapse,
        handlePageSizeSelectChange,
        handleDashboardCollapse } = props;

    return (
        <DashboardCollapse className="select" id="viewing-select" activeDashboardCollapse={activeDashboardCollapse}>
            <div className="select__actions">
                <CloseButton
                    closeDashboardToggleId="#viewing-select"
                    handleDashboardCollapse={handleDashboardCollapse}
                    closeText={closeViewLabel} />
            </div>
            <label htmlFor="viewing">{`${viewLabel} `}</label>
            <Selectric defaultValue={pageSize} onChange={handlePageSizeSelectChange} id="viewing">
                {pageSizeOptions.map((ps, i) => (
                    <option key={`pageSizeOption-${i}`} value={ps}>
                        {ps}
                    </option>
                ))}
            </Selectric>
        </DashboardCollapse>
    );
}